import { countryDialCodes } from './country_dial_codes'
import professionalDesignations from './professional_designations'
import { USA_STATES } from './usa_states'

export const MINIMUN_NUMBER_OF_MEMBERS = 99

export const MAX_NUM_OF_TREATMENTS = 5
export const MAX_NUM_OF_SPECIALITIES = 3

export const jobTitles = [
  { title: 'PhD', value: 'PhD' },
  { title: 'Clinical Social Worker', value: 'Clinical Social Worker' },
]

export { countryDialCodes, USA_STATES, professionalDesignations }
